import * as THREE from 'three';
import { loadModel } from "./Loader";
import { createOutline } from "../System/OutlineShader";
import { LODGroup, registerLODGroup } from '../System/LODManager';

export class RouterModel {
    private lodGroup: LODGroup;

    constructor(type: string, id: string) {
        this.lodGroup = new LODGroup();

        if (type === 'router') {
            // Pour ROUTER
            this.loadModel('assets/three/ROUTER/ROUTER_high.gltf', 1.5, id);
            this.loadModel('assets/three/ROUTER/ROUTER_medium.gltf', 1.0, id);
            this.loadModel('assets/three/ROUTER/ROUTER_low.gltf', 0.0, id);
        } else {
            // Pour FIREWALL
            this.loadModel('assets/three/ROUTER/FIREWALL_high.gltf', 1.5, id);
            this.loadModel('assets/three/ROUTER/FIREWALL_medium.gltf', 1.0, id);
            this.loadModel('assets/three/ROUTER/FIREWALL_low.gltf', 0.0, id);
        }
        registerLODGroup(this.lodGroup);
    }

    private loadModel(url: string, threshold: number, id: string): void {
        loadModel(
            url,
            (gltf: { scene: THREE.Object3D }): void => {
                const model = gltf.scene;

                // Création d’un outline
                const outline = createOutline(model);
                outline.position.y = -0.01;
				outline.userData.targetModelId = id; // Lien vers le modèle
                outline.layers.set(1);

                model.traverse((object: THREE.Object3D): void => {
                    object.layers.set(1);
                    if (object instanceof THREE.Mesh) {
                        object.material = new THREE.MeshBasicMaterial({
                            map: (object.material as THREE.MeshStandardMaterial).map,
                        });
                    }
                });
				model.userData.id = id
				model.userData.outlineRef = outline;

				const container = new THREE.Group();
                container.userData.isLODContainer = true;
				container.userData.id = id;
				model.userData.modelType = "Router"
				container.add(model, outline);
                container.scale.set(0.7, 0.7, 0.7);

                this.lodGroup.addLOD(container, threshold);
            },
            (progress: ProgressEvent): void => {
                // console.log(`Progression : ${(progress.loaded / progress.total) * 100}%`);
            },
            (error: unknown) => {
                console.error('Erreur lors du chargement du modèle GLTF :', error);
            }
        );
    }

    public getGroup(): THREE.Group {
        return this.lodGroup;
    }
}
